import IOrganizationUnit from 'interfaces/users/IOrganizationUnit';

const showOrganizationUnits = (
  organizationUnits: IOrganizationUnit[]
): { label: string; value: number }[] =>
  // Not the units taken out of use (the units of a contact come without the mark)
  organizationUnits
    .filter((x: IOrganizationUnit) => !x.disabled)
    .map((x: IOrganizationUnit) => ({
      value: x.id,
      label: x.name,
    }));

export default showOrganizationUnits;
